import React, { FC, useEffect, useState } from "react";
import { FormGroup, Label, Input, FormFeedback } from "reactstrap";

interface DropdownOption {
  value: string;
  label: string;
}

interface DropdownProps {
  label: string;
  name: string;
  value: string;
  setValue: (name: string, value: string) => void;
  setError?: (name: string, error: boolean) => void;
  options: (string | DropdownOption)[];
  error?: boolean;
  errorMessage?: string;
  required?: boolean;
  className?: string;
  disabled?: boolean;
  design?: "flex" | "default";
  passCol?: string;
  tabIndex?: number;
  onBlur?: (e: React.FocusEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const Dropdown: FC<DropdownProps> = ({
  label,
  name,
  value,
  setValue,
  setError,
  options,
  error,
  errorMessage,
  required = false,
  className,
  disabled,
  design = "default",
  passCol,
  tabIndex,
  onBlur,
}) => {
  const [windowWidth, setWindowWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setValue(name, value);
    if (setError) {
      setError(name, false);
    }
  };

  const flexClass = design === "flex" && windowWidth > 768 ? "d-flex align-items-center" : "";

  const labelWidthClass = design === "flex" && windowWidth > 768 ? "col-3" : "";
  const passColClass = windowWidth > 768 ? passCol : "";
  return (
    <FormGroup className={flexClass}>
      {label && (
        <Label for={name} className={`${design === "flex" ? "mr-5 " : ""}${labelWidthClass}`}>
          {label}
          {required && <span className="text-danger ml-2">*</span>}
        </Label>
      )}
      <div className={passColClass}>
        {error && <FormFeedback className="d-block mt-1">{errorMessage}</FormFeedback>}
        <Input
          type="select"
          name={name}
          id={name}
          value={value}
          tabIndex={tabIndex}
          onChange={handleChange}
          onBlur={onBlur}
          invalid={error}
          disabled={disabled}
        >
          <option value="">Select</option>
          {options.map((option, index) => {
            const optVal = typeof option === "string" ? option : option.value;
            const optLabel = typeof option === "string" ? option : option.label;
            return (
              <option key={index} value={optVal}>
                {optLabel}
              </option>
            );
          })}
        </Input>
      </div>
    </FormGroup>
  );
};

export default Dropdown;
